import { ReachTab, ReachTabsList } from 'components/Reach';
import styled from 'styled-components';

export const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TabListContainer = styled(ReachTabsList)`
  width: 100%;
  display: flex;
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.configs.tertiaryBox.secondaryFontColor};`};
`;

export const TabContainer = styled(ReachTab)`
  display: flex;
  overflow: hidden;
  flex: 1;
  justify-content: center;
  margin-bottom: -2px;
  padding: 12px 10px;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  /* Apply active styles when has data-selected attribute (generated by Reach) */
  &[data-selected] {
    color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
    border-bottom: ${({ theme }) =>
      `3px solid ${theme.configs.tertiaryBox.mainFontColor}`};
  }
`;

export const TabContent = styled.div`
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const PanelContainer = styled.div`
  flex-grow: 1;
`;
